<div class="container-gwall mt-3">
  <fa-icon icon="car-crash" size="10x"></fa-icon>

  <div class="container-gwall">
    <h1>Gwall - {{ codGwall }}</h1>
    <h3>Nid yw'r tudalen yma yn bydoli</h3>
  </div>

  <div class="container-gwall">
    <h1>Error - {{ codGwall }}</h1>
    <h3>This page does not exist</h3>
  </div>
</div>
